import request, { METHODS } from '@/api'
import UrlConfig from '@/api/UrlConfigs.ts'
import { fileDownload } from '@/utils/download'

const { PlusProductWeb, plusPmWeb } = UrlConfig

// 查询枚举
export const getProductEnums = async (path): Promise<any[]> => {
  return request(PlusProductWeb.GetEnums + path, { method: METHODS.GET }).then(
    (res: any) => res || []
  )
}

// 查询参数管理分页
export const getArgPage = async options => {
  return request(PlusProductWeb.GetArgPage, {
    method: METHODS.POST,
    ...options,
  })
}

// 查询参数管理列表
export const getArgList = async (data = {}) => {
  return request(PlusProductWeb.GetArgList, {
    method: METHODS.POST,
    data,
  })
}
// 参数管理保存
export const argSave = async options => {
  return request(PlusProductWeb.ArgSave, {
    method: METHODS.POST,
    ...options,
  })
}
// 参数管理修改
export const argUpdateById = async options => {
  return request(PlusProductWeb.ArgUpdateById, {
    method: METHODS.POST,
    ...options,
  })
}
// 参数管理删除
export const argDelete = async id => {
  return request(PlusProductWeb.ArgDelete + id, {
    method: METHODS.DELETE,
  })
}
// 参数管理修改状态
export const argUpdateState = async options => {
  return request(PlusProductWeb.ArgUpdateState, {
    method: METHODS.POST,
    ...options,
  })
}

// 查询项目管理分页
export const getProjectPage = async options => {
  return request(PlusProductWeb.GetProjectPage, {
    method: METHODS.POST,
    ...options,
  })
}

// 查询项目管理列表
export const getProjectList = async (data = {}) => {
  return request(PlusProductWeb.GetProjectList, {
    method: METHODS.POST,
    data,
  })
}
// 项目管理保存
export const projectSave = async options => {
  return request(PlusProductWeb.ProjectSave, {
    method: METHODS.POST,
    ...options,
  })
}
// 项目管理修改
export const projectUpdateById = async options => {
  return request(PlusProductWeb.ProjectUpdateById, {
    method: METHODS.POST,
    ...options,
  })
}
// 项目管理删除
export const projectDelete = async id => {
  return request(PlusProductWeb.ProjectDelete + id, {
    method: METHODS.DELETE,
  })
}

// 项目管理修改状态
export const projectUpdateState = async data => {
  return request(PlusProductWeb.ProjectUpdateState, {
    method: METHODS.POST,
    data,
  })
}

// 查询品牌管理分页
export const getBrandPage = async options => {
  return request(PlusProductWeb.GetBrandPage, {
    method: METHODS.POST,
    ...options,
  })
}
// 价格计算
export const priceCalculatePriceCalculate = async options => {
  return request(PlusProductWeb.priceCalculatePriceCalculate, {
    method: METHODS.POST,
    ...options,
  })
}
// 价格查询列表
export const querySkuPricePage = async options => {
  return request(PlusProductWeb.querySkuPricePage, {
    method: METHODS.POST,
    ...options,
  })
}
// 价格查询列表数量
export const getAuthSkuCount = async options => {
  return request(PlusProductWeb.GetAuthSkuCount, {
    method: METHODS.POST,
    ...options,
  })
}
// 拉价格数据导出限制条数
export const getBatchSize = async () => {
  return request(PlusProductWeb.getBatchSize, {
    method: METHODS.GET,
  })
}
// 提交导出记录
export const priceExportRecord = async data => {
  return request(PlusProductWeb.priceExportRecord, {
    method: METHODS.POST,
    data,
  })
}
// 查询分批导出记录
export const getPriceExportRecord = async data => {
  return request(PlusProductWeb.getPriceExportRecord, {
    method: METHODS.POST,
    data,
  })
}
// 执行导出
export const doExport = async id => {
  return request(`${PlusProductWeb.doExport}/${id}`, {
    method: METHODS.POST,
    data: {},
  })
}
// 直接导出
export const exportQuerySkuPriceExcel = async data => {
  return fileDownload(PlusProductWeb.exportQuerySkuPriceExcel, {
    method: METHODS.POST,
    data,
  })
}
// 适用产品
export const productSearchList = async data => {
  return request(PlusProductWeb.productSearchList, {
    method: METHODS.POST,
    data,
  })
}

// 查询品牌管理列表
export const getBrandList = async (data = {}) => {
  return request(PlusProductWeb.GetBrandList, {
    method: METHODS.POST,
    data,
  })
}
// 品牌管理保存
export const brandSave = async options => {
  return request(PlusProductWeb.BrandSave, {
    method: METHODS.POST,
    ...options,
  })
}
// 品牌管理修改
export const brandUpdateById = async options => {
  return request(PlusProductWeb.BrandUpdateById, {
    method: METHODS.POST,
    ...options,
  })
}
// 品牌管理删除
export const brandDelete = async id => {
  return request(PlusProductWeb.BrandDelete + id, {
    method: METHODS.DELETE,
  })
}

// 品牌管理修改状态
export const brandUpdateState = async data => {
  return request(PlusProductWeb.BrandUpdateState, {
    method: METHODS.POST,
    data,
  })
}

// 查询业务字典列表
export const getBusinessDictList = async options => {
  return request(PlusProductWeb.GetBusinessDictList, {
    method: METHODS.POST,
    ...options,
  })
}
// 业务字典保存
export const businessDictSave = async options => {
  return request(PlusProductWeb.BusinessDictSave, {
    method: METHODS.POST,
    ...options,
  })
}
// 业务字典修改
export const businessDictUpdateById = async options => {
  return request(PlusProductWeb.BusinessDictUpdateById, {
    method: METHODS.POST,
    ...options,
  })
}
// 业务字典修改状态
export const businessDictUpdateState = async data => {
  return request(PlusProductWeb.BusinessDictUpdateState, {
    method: METHODS.POST,
    data,
  })
}
// 业务字典删除
export const businessDictDelete = async id => {
  return request(PlusProductWeb.BusinessDictDelete + id, {
    method: METHODS.DELETE,
  })
}

// 查询费用项管理分页
export const getPriceItemPage = async options => {
  return request(PlusProductWeb.GetPriceItemPage, {
    method: METHODS.POST,
    ...options,
  })
}

// 查询费用项管理列表
export const getPriceItemList = async (data = {}) => {
  return request(PlusProductWeb.GetPriceItemList, {
    method: METHODS.POST,
    data,
  })
}
// 费用项管理保存
export const priceItemSave = async options => {
  return request(PlusProductWeb.PriceItemSave, {
    method: METHODS.POST,
    ...options,
  })
}
// 费用项管理修改
export const priceItemUpdateById = async options => {
  return request(PlusProductWeb.PriceItemUpdateById, {
    method: METHODS.POST,
    ...options,
  })
}
// 费用项管理删除
export const priceItemDelete = async id => {
  return request(PlusProductWeb.PriceItemDelete + id, {
    method: METHODS.DELETE,
  })
}
// 费用项管理查询
export const priceItemGet = async id => {
  return request(PlusProductWeb.PriceItemDelete + id, {
    method: METHODS.GET,
  })
}
// 费用项管理修改状态
export const priceItemUpdateState = async data => {
  return request(PlusProductWeb.PriceItemUpdateState, {
    method: METHODS.POST,
    data,
  })
}
// 费用项管理修改-是否显示
export const priceItemUpdateShowFlag = async data => {
  return request(PlusProductWeb.PriceItemUpdateShowFlag, {
    method: METHODS.POST,
    data,
  })
}
// 费用项管理修改-是否显示
export const priceItemImportFile = async data => {
  return request(PlusProductWeb.PriceItemImportFile, {
    method: METHODS.POST,
    data,
  })
}

// 查询费用项管理 - 特殊配置分页
export const getPriceItemSpecialConfigPage = async options => {
  return request(PlusProductWeb.GetPriceItemSpecialConfigPage, {
    method: METHODS.POST,
    ...options,
  })
}
// 费用项管理 - 特殊配置保存
export const priceItemSpecialConfigSave = async options => {
  return request(PlusProductWeb.PriceItemSpecialConfigSave, {
    method: METHODS.POST,
    ...options,
  })
}
// 费用项管理 - 特殊配置修改
export const priceItemSpecialConfigUpdateById = async options => {
  return request(PlusProductWeb.PriceItemSpecialConfigUpdateById, {
    method: METHODS.POST,
    ...options,
  })
}
// 费用项管理 - 特殊配置删除
export const priceItemSpecialConfigDelete = async id => {
  return request(PlusProductWeb.PriceItemSpecialConfigDelete + id, {
    method: METHODS.DELETE,
  })
}
// 费用项管理 - 特殊配置删除
export const priceItemSpecialConfigBatchDelete = async ids => {
  return request(PlusProductWeb.PriceItemSpecialConfigBatchDelete, {
    method: METHODS.DELETE,
    data: ids,
  })
}
// 费用项管理 - 特殊配置-导入
export const priceItemSpecialConfigImport = async data => {
  return request(PlusProductWeb.PriceItemSpecialConfigImport, {
    method: METHODS.POST,
    data,
  })
}

// 查询费用项管理 - 导入费用分页
export const getPriceImportFeesPage = async options => {
  return request(PlusProductWeb.GetPriceImportFeesPage, {
    method: METHODS.POST,
    ...options,
  })
}
// 费用项管理 - 导入费用修改
export const priceImportFeesUpdateById = async options => {
  return request(PlusProductWeb.PriceImportFeesUpdateById, {
    method: METHODS.POST,
    ...options,
  })
}
// 费用项管理 - 导入费用删除
export const priceImportFeesBatchDelete = async ids => {
  return request(PlusProductWeb.PriceImportFeesBatchDelete, {
    method: METHODS.DELETE,
    data: ids,
  })
}
// 费用项管理 - 导入费用-导入
export const priceImportFeesImport = async data => {
  return request(PlusProductWeb.PriceImportFeesImport, {
    method: METHODS.POST,
    data,
  })
}

// 查询通项管理分页
export const getGeneralPage = async options => {
  return request(PlusProductWeb.GetGeneralPage, {
    method: METHODS.POST,
    ...options,
  })
}

// 查询通项管理列表
export const getGeneralList = async (data = {}) => {
  return request(PlusProductWeb.GetGeneralList, {
    method: METHODS.POST,
    data,
  })
}
// 通项管理保存
export const generalSave = async options => {
  return request(PlusProductWeb.GeneralSave, {
    method: METHODS.POST,
    ...options,
  })
}
// 通项管理修改
export const generalUpdateById = async options => {
  return request(PlusProductWeb.GeneralUpdateById, {
    method: METHODS.POST,
    ...options,
  })
}
// 通项管理删除
export const generalDelete = async id => {
  return request(PlusProductWeb.GeneralDelete + id, {
    method: METHODS.DELETE,
  })
}
// 通项批量导入
export const generalImportBatchFile = async data => {
  return request(PlusProductWeb.GeneralImportBatchFile, {
    method: METHODS.POST,
    data,
  })
}
// 通项管理修改状态
export const generalUpdateState = async options => {
  return request(PlusProductWeb.GeneralUpdateState, {
    method: METHODS.POST,
    ...options,
  })
}

// 查询通项管理-标配分页
export const getGeneralStandardPage = async options => {
  return request(PlusProductWeb.GetGeneralStandardPage, {
    method: METHODS.POST,
    ...options,
  })
}
// 查询通项管理-标配列表
export const getGeneralStandardList = async (data = {}) => {
  return request(PlusProductWeb.GetGeneralStandardList, {
    method: METHODS.POST,
    data,
  })
}
// 通项管理-标配保存
export const generalStandardSave = async (data = {}) => {
  return request(PlusProductWeb.GeneralStandardSave, {
    method: METHODS.POST,
    data,
  })
}
// 通项管理-标配修改
export const generalStandardUpdateById = async (data = {}) => {
  return request(PlusProductWeb.GeneralStandardUpdateById, {
    method: METHODS.POST,
    data,
  })
}
// 通项管理-标配上传
export const generalStandardImportFile = async data => {
  return request(PlusProductWeb.GeneralStandardImportFile, {
    method: METHODS.POST,
    data,
  })
}
// 通项管理-删除
export const generalStandardDelete = async id => {
  return request(PlusProductWeb.GeneralStandardDelete + id, {
    method: METHODS.DELETE,
  })
}

// 产品管理- 分页
export const getProductManagementPage = async options => {
  return request(PlusProductWeb.GetProductManagementPage, {
    method: METHODS.POST,
    ...options,
  })
}
export const getProductSkuManagementPage = async options => {
  return request(PlusProductWeb.GetProductSkuManagementPage, {
    method: METHODS.POST,
    ...options,
  })
}
// 产品管理- 分页 - 含通用
export const getProductCommonPage = async options => {
  return request(PlusProductWeb.GetProductCommonPage, {
    method: METHODS.POST,
    ...options,
  })
}

//产品管理 - 详情
export const productManagementDetail = async id => {
  return request(`${PlusProductWeb.ProductManagementDetail}${id}`, {
    method: METHODS.GET,
    params: {
      queryTreeNodes: true,
      querySkus: true,
      queryPriceItems: true,
      queryCombinationInfoDetail: true,
      queryCapitalSpecial: true,
    },
  })
}
//产品管理 - SKU详情
export const productSkuDetail = async id => {
  return request(
    `${PlusProductWeb.ProductSkuDetail}${id}`,
    {
      method: METHODS.GET,
      params: {
        queryTreeNodes: true,
        querySkus: true,
        queryPriceItems: true,
        queryCombinationInfoDetail: true,
        queryCapitalSpecial: true,
      }
    }
  )
}

//产品管理 - 详情
// export const productManagementDetail = async id => {
//   return request(
//     `${PlusProductWeb.ProductManagementDetail}${id}?queryTreeNodes=true&querySkus=true&queryPriceItems=true&queryCombinationInfoDetail=true`,
//     {
//       method: METHODS.GET,
//     }
//   )
// }
//产品管理 - 修改
export const productManagementUpdateById = async (data = {}) => {
  return request(PlusProductWeb.ProductManagementUpdateById, {
    method: METHODS.POST,
    data,
  })
}
//产品管理 - 删除
export const productManagementDelete = async id => {
  return request(PlusProductWeb.ProductManagementDelete + id, {
    method: METHODS.DELETE,
  })
}
// 产品管理 - 修改状态
export const productManagementUpdateState = async options => {
  return request(PlusProductWeb.ProductManagementUpdateState, {
    method: METHODS.POST,
    ...options,
  })
}

// sku - 列表
export const getSkuList = async options => {
  return request(PlusProductWeb.GetSkuList, {
    method: METHODS.POST,
    ...options,
  })
}

// sku - 授权列表
export const getAuthSkuList = async options => {
  return request(PlusProductWeb.GetAuthSkuList, {
    method: METHODS.POST,
    ...options,
  })
}

// 查询单品sku价格
export const getSkuPriceCalculate = async (data = {}) => {
  return request(PlusProductWeb.GetSkuPriceCalculate, {
    method: METHODS.POST,
    data,
  })
}

// 查有权限的门店
export const getSkuAllowCompanies = async id => {
  return request(PlusProductWeb.GetSkuAllowCompanies + id, {
    method: METHODS.GET,
  })
}

// 查组合产品明细
export const getSkuCombinationInfo = async (data = {}) => {
  return request(PlusProductWeb.GetSkuCombinationInfo, {
    method: METHODS.POST,
    data,
  })
}

// 查询产品分类管理树形列表
export const getProductCategoryTreeList = async (data = {}): Promise<any[]> => {
  return request(PlusProductWeb.GetProductCategoryTreeList, {
    method: METHODS.POST,
    data,
  })
}
// 产品分类管理保存
export const productCategorySave = async data => {
  return request(PlusProductWeb.ProductCategorySave, {
    method: METHODS.POST,
    data,
  })
}
// 产品分类管理修改
export const productCategoryUpdateById = async data => {
  return request(PlusProductWeb.ProductCategoryUpdateById, {
    method: METHODS.POST,
    data,
  })
}
// 产品分类管理删除
export const productCategoryDelete = async id => {
  return request(PlusProductWeb.ProductCategoryDelete + id, {
    method: METHODS.DELETE,
  })
}
// 产品分类管理修改状态
export const productCategoryUpdateState = async options => {
  return request(PlusProductWeb.ProductCategoryUpdateState, {
    method: METHODS.POST,
    ...options,
  })
}

// 查询价格策略 - 提点率
export const getPriceBoostRatePage = async options => {
  return request(PlusProductWeb.GetPriceBoostRatePage, {
    method: METHODS.POST,
    ...options,
  })
}
// 价格策略 - 提点率 保存
export const priceBoostRateSave = async options => {
  return request(PlusProductWeb.PriceBoostRateSave, {
    method: METHODS.POST,
    ...options,
  })
}
// 价格策略 - 提点率 修改
export const priceBoostRateUpdateById = async options => {
  return request(PlusProductWeb.PriceBoostRateUpdateById, {
    method: METHODS.POST,
    ...options,
  })
}
// 价格策略 - 提点率 删除
export const priceBoostRateDelete = async id => {
  return request(PlusProductWeb.PriceBoostRateDelete + id, {
    method: METHODS.DELETE,
  })
}
// 价格策略 -提点率 删除
export const priceBoostRateBatchDelete = async data => {
  return request(PlusProductWeb.PriceBoostRateBatchDelete, {
    method: METHODS.DELETE,
    data,
  })
}
// 价格策略 -提点率 导入
export const priceBoostRateImport = async data => {
  return request(PlusProductWeb.PriceBoostRateImport, {
    method: METHODS.POST,
    data,
  })
}

// 查询价格策略 - 项目经理利率
export const getPriceProManagerRatePage = async options => {
  return request(PlusProductWeb.GetPriceProManagerRatePage, {
    method: METHODS.POST,
    ...options,
  })
}
// 价格策略 - 项目经理利率 保存
export const priceProManagerRateSave = async options => {
  return request(PlusProductWeb.PriceProManagerRateSave, {
    method: METHODS.POST,
    ...options,
  })
}
// 价格策略 - 项目经理利率 修改
export const priceProManagerRateUpdateById = async options => {
  return request(PlusProductWeb.PriceProManagerRateUpdateById, {
    method: METHODS.POST,
    ...options,
  })
}
// 价格策略 - 项目经理利率 删除
export const priceProManagerRateDelete = async id => {
  return request(PlusProductWeb.PriceProManagerRateDelete + id, {
    method: METHODS.DELETE,
  })
}

// 价格策略 -项目经理利率 删除
export const priceProManagerRateBatchDelete = async data => {
  return request(PlusProductWeb.PriceProManagerRateBatchDelete, {
    method: METHODS.DELETE,
    data,
  })
}
// 价格策略 -项目经理利率 导入
export const priceProManagerRateImport = async data => {
  return request(PlusProductWeb.PriceProManagerRateImport, {
    method: METHODS.POST,
    data,
  })
}

// 查询价格策略 - 毛利
export const getPriceGrossRatePage = async options => {
  return request(PlusProductWeb.GetPriceGrossRatePage, {
    method: METHODS.POST,
    ...options,
  })
}
// 价格策略 - 毛利 保存
export const priceGrossRateSave = async options => {
  return request(PlusProductWeb.PriceGrossRateSave, {
    method: METHODS.POST,
    ...options,
  })
}
// 价格策略 - 毛利 修改
export const priceGrossRateUpdateById = async options => {
  return request(PlusProductWeb.PriceGrossRateUpdateById, {
    method: METHODS.POST,
    ...options,
  })
}
// 价格策略 - 毛利 删除
export const priceGrossRateDelete = async id => {
  return request(PlusProductWeb.PriceGrossRateDelete + id, {
    method: METHODS.DELETE,
  })
}
// 价格策略 -毛利 删除
export const priceGrossRateBatchDelete = async data => {
  return request(PlusProductWeb.PriceGrossRateBatchDelete, {
    method: METHODS.DELETE,
    data,
  })
}
// 价格策略 -毛利 导入
export const priceGrossRateImport = async data => {
  return request(PlusProductWeb.PriceGrossRateImport, {
    method: METHODS.POST,
    data,
  })
}

// 查询价格策略 - 标配。通项
export const getPriceStandardRatePage = async options => {
  return request(PlusProductWeb.GetPriceStandardRatePage, {
    method: METHODS.POST,
    ...options,
  })
}
// 价格策略 - 标配。通项 保存
export const priceStandardRateSave = async options => {
  return request(PlusProductWeb.PriceStandardRateSave + options.data.sourceType, {
    method: METHODS.POST,
    ...options,
  })
}
// 价格策略 - 标配。通项 修改
export const priceStandardRateUpdateById = async options => {
  return request(PlusProductWeb.PriceStandardRateUpdateById, {
    method: METHODS.POST,
    ...options,
  })
}
// 价格策略 - 标配。通项 删除
export const priceStandardRateDelete = async id => {
  return request(PlusProductWeb.PriceStandardRateDelete + id, {
    method: METHODS.DELETE,
  })
}
// 价格策略 - 标配。通项 删除
export const priceStandardRateBatchDelete = async data => {
  return request(PlusProductWeb.PriceStandardRateBatchDelete, {
    method: METHODS.DELETE,
    data,
  })
}
// 价格策略 - 标配。通项 导入
export const priceStandardRateImport = async (data, key) => {
  return request(PlusProductWeb.PriceStandardRateImport + key, {
    method: METHODS.POST,
    data,
  })
}

// 查询子项管理
export const getSubItemManagementPage = async options => {
  return request(PlusProductWeb.GetSubItemManagementPage, {
    method: METHODS.POST,
    ...options,
  })
}
// 子项管理 修改状态
export const subItemManagementUpdateState = async data => {
  return request(PlusProductWeb.SubItemManagementUpdateState, {
    method: METHODS.POST,
    data,
  })
}
// 子项管理 删除
export const subItemManagementDelete = async id => {
  return request(PlusProductWeb.SubItemManagementDelete + id, {
    method: METHODS.DELETE,
  })
}
// 子项管理 下一步暂存
export const SubItemManagementSaveCache = async data => {
  return request(PlusProductWeb.SubItemManagementSaveCache, {
    method: METHODS.POST,
    data,
  })
}
// 子项管理 提交保存
export const subItemManagementSave = async id => {
  return request(PlusProductWeb.SubItemManagementSave, {
    method: METHODS.GET,
    params: { id },
  })
}
// 子项管理 返回取消刷新缓存
export const subItemManagementCleanCache = async id => {
  return request(PlusProductWeb.SubItemManagementCleanCache, {
    method: METHODS.GET,
    params: { id },
  })
}
// 子项管理 查询 第一步-基础数据
export const getSubItemManagementInfo = async id => {
  return request(PlusProductWeb.GetSubItemManagementInfo, {
    method: METHODS.GET,
    params: { id },
  })
}
export const upDateSubItemManagementInfo = async data => {
  return request(PlusProductWeb.UpDateSubItemManagementInfo, {
    method: METHODS.POST,
    data,
  })
}
export const subItemManagementAdd = async data => {
  return request(PlusProductWeb.SubItemManagementAdd, {
    method: METHODS.POST,
    data,
  })
}
// 查询子项管理-新增-子项打包
// 统一调整 子项查询打包结构 方便通项查询
export const getSubPackTreeTempTree = async data => {
  return request(PlusProductWeb.GetSubPackTreeAddTree + data.subItemId, {
    method: METHODS.GET,
    params: { queryTreeNodes: true },
  })
}
// 子项管理-新增-子项打包 新增/编辑 保存
export const subPackTreeTempSave = async data => {
  return request(PlusProductWeb.SubPackTreeSave, {
    method: METHODS.POST,
    data,
  })
}
// 查询子项管理-编辑-子项打包
export const getSubPackTreeEditTree = async data => {
  return request(PlusProductWeb.GetSubPackTreeEditTree, {
    method: METHODS.POST,
    data,
  })
}
// 查询子项管理-编辑-子项打包
export const getSubPackTreeEditTreeTopList = async data => {
  return request(PlusProductWeb.GetSubPackTreeEditTreeTopList, {
    method: METHODS.POST,
    data,
  })
}
// 子项管理-编辑-子项打包 新增/编辑 保存
export const subPackTreeUpdateById = async data => {
  return request(PlusProductWeb.SubPackTreeUpdateById, {
    method: METHODS.POST,
    data,
  })
}
// 子项管理-新增/编辑-子项打包 删除
export const subPackTreeTempDelete = async id => {
  return request(PlusProductWeb.SubPackTreeDelete, {
    method: METHODS.GET,
    params: { id },
  })
}

// 查询打包模板
export const getPackModelPage = async options => {
  return request(PlusProductWeb.GetPackModelPage, {
    method: METHODS.POST,
    ...options,
  })
}
// 查询打包模板list
export const getPackModelList = async options => {
  return request(PlusProductWeb.GetPackModelList, {
    method: METHODS.POST,
    data: { ...options },
  })
}
// 打包模板 修改状态
export const packModelUpdateState = async data => {
  return request(PlusProductWeb.PackModelUpdateState, {
    method: METHODS.POST,
    data,
  })
}
// 打包模板 修改
export const packModelUpdateById = async data => {
  return request(PlusProductWeb.PackModelUpdateById, {
    method: METHODS.POST,
    data,
  })
}
// 打包模板 删除
export const packModelDelete = async id => {
  return request(PlusProductWeb.PackModelDelete + id, {
    method: METHODS.DELETE,
  })
}
// 打包模板 获取详情 带打包树
export const getPackModelDetail = async data => {
  return request(PlusProductWeb.GetPackModelDetail + data.id, {
    method: METHODS.GET,
    params: { ...data.params },
  })
}
// 打包模板 复制
export const packModelCopy = async params => {
  return request(PlusProductWeb.PackModelCopy, {
    method: METHODS.POST,
    params,
  })
}
// 打包模板 获取详情 第一步
// export const getPackModelDetail = async params => {
//   return request(PlusProductWeb.PackModelDetail, {
//     method: METHODS.POST,
//     params,
//   })
// }
// 打包模板 新增保存
export const packModelSave = async data => {
  return request(PlusProductWeb.PackModelSave, {
    method: METHODS.POST,
    data,
  })
}
// 打包模板 提交
export const packModelSubmit = async data => {
  return request(PlusProductWeb.PackModelSubmit, {
    method: METHODS.POST,
    data,
  })
}
// 打包模板 规格保存
export const packModelArgSave = async data => {
  return request(PlusProductWeb.PackModelArgSave, {
    method: METHODS.POST,
    data,
  })
}
// 打包模板 规格详情
export const packModelArgDetail = async data => {
  return request(PlusProductWeb.PackModelArgDetail, {
    method: METHODS.POST,
    data,
  })
}
// 打包模板 规格 - 添加配置获取sku
export const packModelCreateSkuByArgs = async data => {
  return request(PlusProductWeb.PackModelCreateSkuByArgs, {
    method: METHODS.POST,
    data,
  })
}
// 打包模板 规格、打包 - sku 打包缓存
export const packModelSkuSave = async data => {
  return request(PlusProductWeb.PackModelSkuSave, {
    method: METHODS.POST,
    data,
  })
}
// 打包模板 规格 - 添加配置获取sku
export const packModelSkuDetail = async data => {
  return request(PlusProductWeb.PackModelSkuDetail, {
    method: METHODS.POST,
    data,
  })
}

// 打包模板 打包树 保存
export const packModelTreeSave = async data => {
  return request(PlusProductWeb.PackModelTreeSave, {
    method: METHODS.POST,
    data,
  })
}
// 打包模板 打包树 添加节点保存
export const packModelTreeCreateTreeId = async data => {
  return request(PlusProductWeb.PackModelTreeCreateTreeId, {
    method: METHODS.POST,
    data,
  })
}
// 打包模板 打包树 编辑节点保存
export const packModelTreeUpdateTreeById = async data => {
  return request(PlusProductWeb.PackModelTreeUpdateTreeById, {
    method: METHODS.POST,
    data,
  })
}

// 打包模板 打包树 详情
export const packModelTreeDetail = async options => {
  return request(PlusProductWeb.PackModelTreeDetail, {
    method: METHODS.POST,
    ...options,
  })
}

// 打包模板 打包树 详情 仅获取缓存
export const getCachePackModelTreeDetail = async options => {
  return request(PlusProductWeb.GetCachePackModelTreeDetail, {
    method: METHODS.POST,
    ...options,
  })
}

// 打包模板 打包树 提交
export const packModelTreeSubmit = async params => {
  return request(PlusProductWeb.PackModelTreeSubmit, {
    method: METHODS.POST,
    params,
  })
}

// 商品管理 - 上下架 关联产品的动态属性及下拉列表
export const getGoodsManagementGoodsBaseInfo = async options => {
  return request(PlusProductWeb.GetGoodsManagementGoodsBaseInfo, {
    method: METHODS.GET,
    ...options,
  })
}

// 产品管理 获取产品服务下拉数据
export const findServiceNodeList = data => {
  return request(`${UrlConfig.plusPmWeb.FindServiceNodeConfig}`, {
    method: METHODS.POST,
    data: data,
  })
}

// 产品管理 保存产品和附件缓存-下一步

export const saveCacheProductAndAttachs = data => {
  return request(`${UrlConfig.PlusProductWeb.SaveCacheProductAndAttachs}`, {
    method: METHODS.POST,
    data: data,
  })
}
// 根据参数规格生成sku-添加配置
export const createSkuByArgs = data => {
  return request(`${UrlConfig.PlusProductWeb.CreateSkuByArgs}`, {
    method: METHODS.POST,
    data: data,
  })
}
// 根据参数规格生成sku-添加配置
export const saveCacheArgManageShortcut = data => {
  return request(`${UrlConfig.PlusProductWeb.SaveCacheArgManageShortcut}`, {
    method: METHODS.POST,
    data: data,
  })
}
// 新增产品
export const saveProduct = data => {
  return request(`${UrlConfig.PlusProductWeb.SaveProduct}`, {
    method: METHODS.POST,
    data: data,
  })
}
// 根据参数规格生成sku-添加配置
export const saveCacheProductRuleDtl = data => {
  return request(`${UrlConfig.PlusProductWeb.SaveCacheProductRuleDtl}`, {
    method: METHODS.POST,
    data: data,
  })
}
// 根据参数规格生成sku-添加配置 -删除
export const deleteCacheProductRuleDtl = data => {
  return request(`${UrlConfig.PlusProductWeb.DeleteCacheProductRuleDtl}`, {
    method: METHODS.POST,
    data: data,
  })
}
// 产品将缓存转为业务数据
export const submitProductInfo = id => {
  return request(`${UrlConfig.PlusProductWeb.SubmitProductInfo}`, {
    method: METHODS.POST,
    params: { prodId: id },
  })
}
// 查询产品和附件-先缓存次业务
export const getOrCacheProductAndAttachs = data => {
  return request(`${UrlConfig.PlusProductWeb.GetOrCacheProductAndAttachs}`, {
    method: METHODS.POST,
    data: data,
  })
}
// 查询参数快照-先缓存次业务
export const getOrCacheArgManageShortcut = data => {
  return request(`${UrlConfig.PlusProductWeb.GetOrCacheArgManageShortcut}`, {
    method: METHODS.POST,
    data: data,
  })
}

// 查询价格管理-先缓存次业务
export const getOrCacheProductRuleDtl = data => {
  return request(`${UrlConfig.PlusProductWeb.GetOrCacheProductRuleDtl}`, {
    method: METHODS.POST,
    data: data,
  })
}
// 复制产品
export const copyProductInfo = data => {
  return request(`${UrlConfig.PlusProductWeb.CopyProductInfo}`, {
    method: METHODS.POST,
    params: { ...data },
  })
}
// 查询产品价格关联-先缓存次业务
export const getOrCacheProductPriceRel = data => {
  return request(`${UrlConfig.PlusProductWeb.GetOrCacheProductPriceRel}`, {
    method: METHODS.POST,
    data: data,
  })
}
// 查询产品价格关联-只查缓存
export const getCacheProductPriceRel = data => {
  return request(`${UrlConfig.PlusProductWeb.GetCacheProductPriceRel}`, {
    method: METHODS.POST,
    data: data,
  })
}
// 保存sku关联价格缓存
export const saveCacheProductPriceRel = data => {
  return request(`${UrlConfig.PlusProductWeb.SaveCacheProductPriceRel}`, {
    method: METHODS.POST,
    data: data,
  })
}

// 查询产品价格关联-先缓存次业务
export const getProdPriceManagePage = (pageId, pageSize, data) => {
  return request(
    `${UrlConfig.PlusProductWeb.GetProdPriceManagePage}` + `?pageId=${pageId}&pageSize=${pageSize}`,
    {
      method: METHODS.POST,
      data: data,
    }
  )
}

// 打包模板 打包树 详情
export const getTreeDetail = async params => {
  return request(PlusProductWeb.PackModelTreeDetail, {
    method: METHODS.POST,
    params,
    data: {},
  })
}

// 规则变量获取
export const getFormulaRuleVariablesList = (data = {}) => {
  return request(PlusProductWeb.GetFormulaRuleVariablesList, {
    method: METHODS.POST,
    data,
  })
}
// 规则运算符获取
export const getFormulaRuleSymbols = (data = {}) => {
  return request(PlusProductWeb.GetFormulaRuleSymbols, {
    method: METHODS.POST,
    data,
  })
}
// 规则获取当前运算变量
export const getFormulaRuleQlPredictInputVar = (data = {}) => {
  return request(PlusProductWeb.GetFormulaRuleQlPredictInputVar, {
    method: METHODS.POST,
    data,
  })
}
// 规则测算
export const calculationResult = (data = {}) => {
  return request(PlusProductWeb.CalculationResult, {
    method: METHODS.POST,
    data,
  })
}
// 获取产品分类
export const findProdCateTreeList = (data = {}) => {
  return request(PlusProductWeb.FindProdCateTreeList, {
    method: METHODS.POST,
    data,
  })
}
// 获取产品服务下拉数据
export const findServiceId = (data = {}) => {
  return request(plusPmWeb.FindServiceId, {
    method: METHODS.POST,
    data,
  })
}
// 获取产品服务下拉数据
export const operateCacheProductPriceRel = (data = {}) => {
  return request(PlusProductWeb.OperateCacheProductPriceRel, {
    method: METHODS.POST,
    data,
  })
}
// 获取产品服务下拉数据
export const deleteCacheProduct = (options = {}) => {
  return request(PlusProductWeb.DeleteCacheProduct, {
    method: METHODS.POST,
    ...options,
  })
}
// 获取特项代码分页列表
export const getSpecialCodes = (options = {}) => {
  return request(PlusProductWeb.GetSpecialCodes, {
    method: METHODS.POST,
    ...options,
  })
}
// 特项代码删除
export const deleteSpecialCode = async id => {
  return request(PlusProductWeb.SpecialCodeOperate + '/' + id, {
    method: METHODS.DELETE,
  })
}
//特项代码 Id删除数据 新增
export const specialCodeAdd = async option => {
  return request(PlusProductWeb.SpecialCodeOperate, {
    method: METHODS.POST,
    ...option,
  })
}
export const updateSpecialCodes = async option => {
  return request(PlusProductWeb.UpdateSpecialCodes, {
    method: METHODS.POST,
    ...option,
  })
}
// 获取特项代码list
export const getSpecialCodesList = (options: any) => {
  return request(PlusProductWeb.GetSpecialCodesList, {
    method: METHODS.POST,
    ...options,
    data: {
      ...options.data,
      enabled: true,
    },
  })
}
// 获取特项代码list
export const getSpecialCodesListNew = (options: any) => {
  return request(PlusProductWeb.GetSpecialCodesList, {
    method: METHODS.POST,
    ...options,
    data: {
      ...options.data,
    },
  })
}
// 拉产品列表
export const getProductList = (data = {}) => {
  return request(PlusProductWeb.GetProductList, {
    method: METHODS.POST,
    data,
  })
}
// 获取单位管理分页列表
export const getunitPage = (options = {}) => {
  return request(PlusProductWeb.GetunitPage, {
    method: METHODS.POST,
    ...options,
  })
}
//单位管理 Id删除数据 新增
export const unitOperateAdd = async option => {
  return request(PlusProductWeb.UnitOperate, {
    method: METHODS.POST,
    ...option,
  })
}
export const updateUnit = async option => {
  return request(PlusProductWeb.UpdateUnit, {
    method: METHODS.POST,
    ...option,
  })
}
// 获取单位管理list
export const getunitList = (options = {}) => {
  return request(PlusProductWeb.GetunitList, {
    method: METHODS.POST,
    ...options,
  })
}
export const getSkuPageList = (options = {}) => {
  return request(PlusProductWeb.GetSkuPageList, {
    method: METHODS.POST,
    ...options,
  })
}
export const getSpuPageList = (options = {}) => {
  return request(PlusProductWeb.GetSpuPageList, {
    method: METHODS.POST,
    ...options,
  })
}
export const generalStandardAdd = (options = {}) => {
  return request(PlusProductWeb.GeneralStandardAdd, {
    method: METHODS.POST,
    ...options,
  })
}
export const deletedBatchByIds = (options = {}) => {
  return request(PlusProductWeb.DeletedBatchByIds, {
    method: METHODS.POST,
    ...options,
  })
}
// 优惠系数 - 分页
export const discountRatioManagePage = async options => {
  return request(PlusProductWeb.DiscountRatioManagePage, {
    method: METHODS.POST,
    ...options,
  })
}
// 优惠系数 - 批量删除
export const deletedBatchByIdsDiscountRatioManage = (options = {}) => {
  return request(PlusProductWeb.DeletedBatchByIdsDiscountRatioManage, {
    method: METHODS.POST,
    ...options,
  })
}
// 优惠系数 - 单个删除
export const deleteDiscountRatioManage = async id => {
  return request(PlusProductWeb.DeleteDiscountRatioManage + id, {
    method: METHODS.DELETE,
  })
}
// 优惠系数-上传
export const importFileDeleteDiscount = async data => {
  return request(PlusProductWeb.ImportFileDeleteDiscount, {
    method: METHODS.POST,
    data,
  })
}

// 优惠系数-保存
export const addDiscountRatioManage = async (data = {}) => {
  return request(PlusProductWeb.AddDiscountRatioManage, {
    method: METHODS.POST,
    data,
  })
}
// 优惠系数-修改
export const updateDiscountRatioManage = async (data = {}) => {
  return request(PlusProductWeb.UpdateDiscountRatioManage, {
    method: METHODS.POST,
    data,
  })
}
// 费用项 违约金
export const breakManagePage = async (data = {}) => {
  return request(PlusProductWeb.BreakManagePage, {
    method: METHODS.POST,
    ...data,
    data: {
      orderBys: [
        //排序传参
        {
          columnName: 'id',
          asc: true,
        },
      ],
    },
  })
}

export const breakManageUpdateById = async data => {
  return request(PlusProductWeb.BreakManageUpdateById, {
    method: METHODS.POST,
    ...data,
  })
}
export const idGenerate = async data => {
  return request(PlusProductWeb.IdGenerate, {
    method: METHODS.GET,
    ...data,
  })
}
export const batchIdGenerate = async (size: number) => {
  return request(PlusProductWeb.BatchIdGenerate + size, {
    method: METHODS.GET,
  })
}
export const saveBatchList = async data => {
  return request(PlusProductWeb.SaveBatchList, {
    method: METHODS.POST,
    data,
  })
}
// 批量添加通项标配
export const generalStandardBatchAdd = async data => {
  return request(PlusProductWeb.GeneralStandardBatchAdd, {
    method: METHODS.POST,
    data,
  })
}

// 拉活动列表
export const getActivityList = (option = {}) => {
  return request(PlusProductWeb.GetActivityList, {
    method: METHODS.POST,
    ...option,
  })
}
// 删除活动
export const deleteActivity = (id = '') => {
  return request(`${PlusProductWeb.DeleteActivity}/${id}`, {
    method: METHODS.DELETE,
  })
}

// 活动类型
export const activityType = () => {
  return request(PlusProductWeb.ActivityType, {
    method: METHODS.GET,
  })
}

// 新增活动
export const addActivity = (data = {}) => {
  return request(PlusProductWeb.AddActivity, {
    method: METHODS.POST,
    data,
  })
}

// 编辑活动
export const updateActivity = (data = {}) => {
  return request(PlusProductWeb.UpdateActivity, {
    method: METHODS.POST,
    data,
  })
}

// 拉活动产品列表
export const getActivityProductList = (option = {}) => {
  return request(PlusProductWeb.GetActivityProductList, {
    method: METHODS.POST,
    ...option,
  })
}

// 删除活动产品
export const deleteActivityProduct = (id = '') => {
  return request(`${PlusProductWeb.DeleteActivityProduct}/${id}`, {
    method: METHODS.DELETE,
  })
}

// 查活动产品详情
export const getActivityProductDetail = (id = '') => {
  return request(`${PlusProductWeb.GetActivityProductDetail}/${id}?queryProduct=true`, {
    method: METHODS.GET,
  })
}

// 新增活动产品
export const addActivityProduct = (data = {}) => {
  return request(PlusProductWeb.AddActivityProduct, {
    method: METHODS.POST,
    data,
  })
}

// 编辑活动产品
export const updateActivityProduct = (data = {}) => {
  return request(PlusProductWeb.UpdateActivityProduct, {
    method: METHODS.POST,
    data,
  })
}

// 活动产品-活动类型
export const getActivityProductType = () => {
  return request(PlusProductWeb.ActivityProductType, {
    method: METHODS.GET,
  })
}

// 活动产品-优惠类型
export const getPromoType = () => {
  return request(PlusProductWeb.PromoType, {
    method: METHODS.GET,
  })
}

// 活动产品-优惠形式
export const getPromoStyle = () => {
  return request(PlusProductWeb.PromoStyle, {
    method: METHODS.GET,
  })
}

// 活动产品-限制类型
export const getActivityProductLimitType = () => {
  return request(PlusProductWeb.ActivityProductLimitType, {
    method: METHODS.GET,
  })
}

// 活动产品-交付限制类型
export const getActivityProductPmsLimitType = () => {
  return request(PlusProductWeb.ActivityProductPmsLimitType, {
    method: METHODS.GET,
  })
}

// 活动产品-活动成本归属
export const getActiveCostBelong = () => {
  return request(PlusProductWeb.ActiveCostBelong, {
    method: METHODS.GET,
  })
}

// sku列表
export const getProductSkuList = data => {
  return request(PlusProductWeb.GetProductSkuList, {
    method: METHODS.POST,
    data,
  })
}
// 批量启用sku
export const batchUpdateProductSkuEnabled = data => {
  return request(PlusProductWeb.BatchUpdateProductSkuEnabled, {
    method: METHODS.POST,
    data,
  })
}

// 拉活动产品门店限制列表
export const getActivityProductShopLimitList = (option = {}) => {
  return request(PlusProductWeb.GetActivityProductShopLimitList, {
    method: METHODS.POST,
    ...option,
  })
}

// 查活动产品门店限制详情
export const getActivityProductShopLimitDetail = (id = '') => {
  return request(`${PlusProductWeb.GetActivityProductShopLimitDetail}/${id}?queryProduct=true`, {
    method: METHODS.GET,
  })
}

// 删除活动产品门店限制
export const deleteActivityProductShopLimit = (id = '') => {
  return request(`${PlusProductWeb.DeleteActivityProductShopLimit}/${id}`, {
    method: METHODS.DELETE,
  })
}

// 新增活动产品门店限制
export const addActivityProductShopLimit = (data = {}) => {
  return request(PlusProductWeb.AddActivityProductShopLimit, {
    method: METHODS.POST,
    data,
  })
}

// 编辑活动产品门店限制
export const updateActivityProductShopLimit = (data = {}) => {
  return request(PlusProductWeb.UpdateActivityProductShopLimit, {
    method: METHODS.POST,
    data,
  })
}

// 拉活动产品sku列表
export const getActivityProductSkuDetailList = (option = {}) => {
  return request(PlusProductWeb.GetActivityProductSkuDetailList, {
    method: METHODS.POST,
    ...option,
  })
}

// 删除活动产品
export const deleteActivityProductSkuDetail = (id = '') => {
  return request(`${PlusProductWeb.DeleteActivityProductSkuDetail}/${id}`, {
    method: METHODS.DELETE,
  })
}

// 新增活动产品sku
export const addActivityProductSkuDetail = (data = {}) => {
  return request(PlusProductWeb.AddActivityProductSkuDetail, {
    method: METHODS.POST,
    data,
  })
}

// 查组合产品信息
export const queryProduct = async (data: any) => {
  return await request(PlusProductWeb.QueryProduct, {
    method: METHODS.POST,
    data,
  })
}

// 更新产品启用停用
export const updateProductEnabled = async (data: any) => {
  return await request(PlusProductWeb.UpdateProductEnabled, {
    method: METHODS.POST,
    data,
  })
}
// 批量删除产品
export const batchDeleteProduct = async (data: any) => {
  return await request(PlusProductWeb.BatchDelete, {
    method: METHODS.POST,
    data,
  })
}

// 产品分类 下载模板
export const ProductCategoryTemplateDownload = async (data: any) => {
  return await request(PlusProductWeb.ProductCategoryTemplateDownload, {
    method: METHODS.POST,
    data,
  })
}
// 产品分类 导入
export const ProductCategoryImportCategory = async (data: any) => {
  return await request(PlusProductWeb.ProductCategoryImportCategory, {
    method: METHODS.POST,
    data,
  })
}

// 导入产品
export const importBaseProductInfo = async (data: any) => {
  return await request(PlusProductWeb.ImportBaseProductInfo, {
    method: METHODS.POST,
    data,
  })
}

// 导入组合产品
export const importCombinationProductInfo = async (data: any) => {
  return await request(PlusProductWeb.ImportCombinationProductInfo, {
    method: METHODS.POST,
    data,
  })
}

// 组合产品分页查询
export const getCombinationProductList = async (options: any) => {
  return await request(PlusProductWeb.GetCombinationProductList, {
    method: METHODS.POST,
    ...options,
  })
}

// 删除组合产品
export const deleteCombinationProductInfo = async (id: any) => {
  return await request(`${PlusProductWeb.DeleteCombinationProductInfo}/${id}`, {
    method: METHODS.DELETE,
  })
}
// 新增组合产品
export const addCombinationProductInfo = async (data) => {
  return await request(`${PlusProductWeb.DeleteCombinationProductInfo}`, {
    method: METHODS.POST,
    data,
  })
}

// 批量删除组合产品
export const batchDeleteCombinationProductInfo = async (data: any) => {
  return await request(PlusProductWeb.BatchDeleteCombinationProductInfo, {
    method: METHODS.DELETE,
    data: {
      ids: data,
    },
  })
}

// 查组合包含的sku
export const getCombinationSkuList = (id, options: any) => {
  return request(`${PlusProductWeb.GetCombinationSkuList}/${id}`, {
    method: METHODS.POST,
    ...options,
  })
}

// 发包配置列表
export const getSendPackConfigList = async (options: any) => {
  return await request(PlusProductWeb.GetSendPackConfigList, {
    method: METHODS.POST,
    ...options,
  })
}

// 删除发包配置
export const deleteSendPackConfig = async (id: any) => {
  return await request(`${PlusProductWeb.DeleteSendPackConfig}/${id}`, {
    method: METHODS.DELETE,
  })
}

// 批量删除发包配置
export const batchDeleteSendPackConfig = async (data: any) => {
  return await request(PlusProductWeb.BatchDeleteSendPackConfig, {
    method: METHODS.POST,
    data,
  })
}

// 导入发包配置
export const importSendPackConfig = async (data: any) => {
  return await request(PlusProductWeb.ImportSendPackConfig, {
    method: METHODS.POST,
    data,
  })
}

// 导出数据
export const exportCombinationProductInfo = async (data: any) => {
  return await request(PlusProductWeb.ExportCombinationProductInfo, {
    method: METHODS.POST,
    data,
  })
}

// 导入sku
export const importSkuInfo = async (data: any) => {
  return await request(PlusProductWeb.ImportSkuInfo, {
    method: METHODS.POST,
    data,
  })
}

// 销售指导价检查
export const salePriceCheck = (id = '') => {
  return request(`${PlusProductWeb.SalePriceCheck}/${id}`, {
    method: METHODS.GET,
  })
}
// 打包模板 模板下载 数据导出
export const buildExcel = (data: any) => {
  return request(PlusProductWeb.BuildExcel, {
    method: METHODS.POST,
    data,
  })
}
// 打包模板 数据导入
export const ReadExcel = (data: any) => {
  return request(PlusProductWeb.ReadExcel, {
    method: METHODS.POST,
    data,
  })
}
// 打包模板 数据导入(编辑时导入)
export const packModelEditImportExcel = (data: any) => {
  return request(PlusProductWeb.PackModelEditImportExcel, {
    method: METHODS.POST,
    data,
  })
}
// 新增报价面积类型
export const addBudgetArea = data => {
  return request(PlusProductWeb.AddBudgetArea, {
    method: METHODS.POST,
    data,
  })
}

// 查报价面积列表
export const getBudgetAreaList = data => {
  return request(PlusProductWeb.GetBudgetAreaList, {
    method: METHODS.POST,
    data,
  })
}

// 编辑报价面积类型
export const updateBudgetArea = data => {
  return request(PlusProductWeb.UpdateBudgetArea, {
    method: METHODS.POST,
    data,
  })
}

// 删除报价面积类型
export const delBudgetArea = async (id: any) => {
  return await request(`${PlusProductWeb.DelBudgetArea}/${id}`, {
    method: METHODS.DELETE,
  })
}
export const getUpdateNodes = () => {
  return request(PlusProductWeb.GetUpdateNodes, {
    method: METHODS.GET,
  })
}
export const GetTemplateCount = options => {
  return request(PlusProductWeb.GetTemplateCount, {
    method: METHODS.POST,
    ...options,
  })
}

// 导入产品
export const importActivityInfo = async (data: any, id) => {
  return await request(`${PlusProductWeb.ImportActivityInfo}/${id}`, {
    method: METHODS.POST,
    data,
  })
}
// 查询空间参数管理分页
export const getSpaceArgPage = async options => {
  return request(PlusProductWeb.GetSpaceArgPage, {
    method: METHODS.POST,
    ...options,
  })
}
// 空间参数管理 新增
export const addSpaceSpecificationArg = async options => {
  return request(PlusProductWeb.AddSpaceSpecificationArg, {
    method: METHODS.POST,
    ...options,
  })
}
// 空间参数管理 编辑
export const spaceSpecificationArgUpdateById = async options => {
  return request(PlusProductWeb.SpaceSpecificationArgUpdateById, {
    method: METHODS.POST,
    ...options,
  })
}

// 空间参数管理修改状态
export const spaceSpecificationArgUpdateState = async options => {
  return request(PlusProductWeb.SpaceSpecificationArgUpdateState, {
    method: METHODS.POST,
    ...options,
  })
}
// 空间参数管理删除
export const SpaceSpecificationArgDelete = async id => {
  return request(PlusProductWeb.SpaceSpecificationArgDelete + id, {
    method: METHODS.DELETE,
  })
}

// 查询费用项管理 - 导入费用分页 限购类型
export const getPriceLimitImportFeesPage = async options => {
  return request(PlusProductWeb.GetPriceLimitImportFeesPage, {
    method: METHODS.POST,
    ...options,
  })
}
// 费用项管理 - 导入费用修改 限购类型
export const priceLimitImportFeesUpdateById = async options => {
  return request(PlusProductWeb.PriceLimitImportFeesUpdateById, {
    method: METHODS.POST,
    ...options,
  })
}
// 费用项管理 - 导入费用删除 限购类型
export const priceLimitImportFeesBatchDelete = async ids => {
  return request(PlusProductWeb.PriceLimitImportFeesBatchDelete, {
    method: METHODS.DELETE,
    data: ids,
  })
}
// 费用项管理 - 导入费用-导入 限购类型
export const priceLimitImportFeesImport = async data => {
  return request(PlusProductWeb.PriceLimitImportFeesImport, {
    method: METHODS.POST,
    data,
  })
}
// 查询费用项管理 - 获取空间参数list 限购类型
export const getSpaceSpecificationArgList = async id => {
  return request(PlusProductWeb.GetSpaceSpecificationArgList + '/' + id, {
    method: METHODS.GET,
  })
}
// 拉空间规格参数列表
export const getSpaceSpecificationArg = async (data: any) => {
  return await request(PlusProductWeb.GetSpaceSpecificationArg, {
    method: METHODS.POST,
    data,
  })
}

// 拉打包模板空间列表
export const getSpaceTagsByPackModelId = async (id: any) => {
  return await request(`${PlusProductWeb.GetSpaceTagsByPackModelId}/${id}`, {
    method: METHODS.GET,
  })
}

// 保存或更新打包空间配置和节点
export const submitConfigAndNode = async data => {
  return await request(PlusProductWeb.SubmitConfigAndNode, {
    method: METHODS.POST,
    data,
  })
}

// 查询打包节点-根据打包模板ID
export const getPackTreeNode = async data => {
  return await request(PlusProductWeb.GetPackTreeNode, {
    method: METHODS.POST,
    data,
  })
}

// 查询空间规格设置-根据打包模板ID
export const getPackModelSpaceConfig = async data => {
  return await request(PlusProductWeb.GetPackModelSpaceConfig, {
    method: METHODS.POST,
    data,
  })
}

// 费用模板列表
export const getCostTemplateList = async (data: any) => {
  return await request(PlusProductWeb.GetCostTemplateList, {
    method: METHODS.POST,
    data,
  })
}

// 查询费用项列表
export const getPriceItemDetail = async (data: any) => {
  return await request(PlusProductWeb.GetPriceItemDetail, {
    method: METHODS.GET,
    params: data,
  })
}

// 获取费用模版
export const getCostTemplate = async (options: any) => {
  return await request(PlusProductWeb.GetCostTemplate, {
    method: METHODS.POST,
    ...options,
  })
}

// 新增费用模版
export const addCostTemplate = async (data: any) => {
  return await request(PlusProductWeb.AddCostTemplate, {
    method: METHODS.POST,
    data,
  })
}

// 编辑费用模版
export const updateCostTemplate = async (data: any) => {
  return await request(PlusProductWeb.UpdateCostTemplate, {
    method: METHODS.POST,
    data,
  })
}

// 修改费用模版状态
export const updateCostTemplateState = async (data: any) => {
  return await request(PlusProductWeb.UpdateCostTemplateState, {
    method: METHODS.POST,
    data,
  })
}

// 删除费用模版
export const deleteCostTemplate = async (id: any) => {
  return await request(`${PlusProductWeb.DeleteCostTemplate}/${id}`, {
    method: METHODS.DELETE,
  })
}

// 复制费用模板
export const copyCostTemplate = async (data: any) => {
  return await request(PlusProductWeb.CopyCostTemplate, {
    method: METHODS.POST,
    params: data,
  })
}

// 获取费用模版详情
export const getCostTemplateDetail = async (options: any) => {
  return await request(PlusProductWeb.GetCostTemplateDetail, {
    method: METHODS.POST,
    ...options,
  })
}

// 批量导入模版
export const importCostTemplate = async (data: any) => {
  return await request(PlusProductWeb.ImportCostTemplate, {
    method: METHODS.POST,
    ...data,
  })
}

// 新增费用模版配置
export const addCostTemplateDetail = async (data: any) => {
  return await request(PlusProductWeb.AddCostTemplateDetail, {
    method: METHODS.POST,
    ...data,
  })
}

// 删除费用模版配置
export const deleteCostTemplateDetail = async (id: any) => {
  return await request(`${PlusProductWeb.DeleteCostTemplateDetail}/${id}`, {
    method: METHODS.DELETE,
  })
}

// 批量删除费用模版配置
export const deleteCostTemplateBatch = async (data: any) => {
  return await request(PlusProductWeb.DeleteCostTemplateDetailBatch, {
    method: METHODS.POST,
    data,
  })
}

// 获取费用模版详情所属分类类型
export const getCostTemplateDetailCategoryType = async () => {
  return await request(PlusProductWeb.GetCostTemplateDetailCategoryType, {
    method: METHODS.GET,
  })
}

// 费用模板选择费用项分页查询
export const findCostItemPage = async (options: any) => {
  return await request(PlusProductWeb.FindCostItemPage, {
    method: METHODS.POST,
    ...options,
  })
}

// 加入费用项
export const addCostItem = async (data: any) => {
  return await request(PlusProductWeb.AddCostItem, {
    method: METHODS.POST,
    data,
  })
}

// 查询提交数据
export const findResponseListByPage = async data => {
  return await request(
    PlusProductWeb.FindResponseListByPage + `?current=${data.current}&pageSize=${data.pageSize}`,
    {
      method: METHODS.POST,
      data: data,
    }
  )
} // 查询失败数据
export const findErrorResponseListByPage = async (data: any) => {
  return await request(
    PlusProductWeb.FindErrorResponseListByPage +
      `?current=${data.current}&pageSize=${data.pageSize}`,
    {
      method: METHODS.POST,
      data,
    }
  )
}
// 工艺说明-查询分页列表
export const materialDescriptionPage = (options = {}) => {
  return request(PlusProductWeb.MaterialDescriptionPage, {
    method: METHODS.POST,
    ...options,
  })
}
// 工艺说明-导入
export const materialDescriptionImport = (options = {}) => {
  return request(PlusProductWeb.MaterialDescriptionImport, {
    method: METHODS.POST,
    ...options,
  })
}

// 工艺说明删除
export const materialDescriptionDelete = async id => {
  return request(PlusProductWeb.MaterialDescriptionDelete + '/' + id, {
    method: METHODS.DELETE,
  })
}
//工艺说明  新增
export const materialDescriptionAdd = async option => {
  return request(PlusProductWeb.MaterialDescriptionAdd, {
    method: METHODS.POST,
    ...option,
  })
}
// 工艺说明  编辑
export const materialDescriptionUpdate = async option => {
  return request(PlusProductWeb.MaterialDescriptionUpdate, {
    method: METHODS.POST,
    ...option,
  })
}
// 获取SPU减项计价方式
export const getDeductivePricingEnum = async () => {
  return await request(PlusProductWeb.DeductivePricingEnum, {
    method: METHODS.GET,
  })
}
// 费用项导入费用-批量修改日期
export const priceImportFeesBatchUpdateDate = async option => {
  return request(PlusProductWeb.PriceImportFeesBatchUpdateDate, {
    method: METHODS.POST,
    ...option,
  })
}
// 费用项限价导入-批量修改日期
export const priceLimitImportFeesBatchUpdateDate = async option => {
  return request(PlusProductWeb.PriceLimitImportFeesBatchUpdateDate, {
    method: METHODS.POST,
    ...option,
  })
}
// 费用项特殊配置-批量修改日期
export const priceSpecialConfigBatchUpdateDate = async option => {
  return request(PlusProductWeb.PriceSpecialConfigBatchUpdateDate, {
    method: METHODS.POST,
    ...option,
  })
}
// 费用项-批量导入
export const priceImportFeesBatchImport = async data => {
  return request(PlusProductWeb.PriceImportFeesBatchImport, {
    method: METHODS.POST,
    data,
  })
}
// 产品管理-批量修改适用选材
export const batchUpdateApplyMaterialSelections = async option => {
  return request(PlusProductWeb.BatchUpdateApplyMaterialSelections, {
    method: METHODS.POST,
    ...option,
  })
}
// 产品管理-批量修改适用选材
export const getConstructionCostList = async option => {
  return request(PlusProductWeb.GetConstructionCostList, {
       method: METHODS.POST,
    ...option,
  })
}
  // 查询规格
export const findSpuFormatPage = async options => {
  return request(UrlConfig.MpmsWeb.FindSpuFormatPage, {
    method: METHODS.POST,
    ...options,
  })
}
  // 查询型号
export const findSpuModelPage = async options => {
  return request(UrlConfig.MpmsWeb.FindSpuModelPage, {
    method: METHODS.POST,
    ...options,
  })
}
// 选品-手动发送通知
export const sndNotifyForHandle = async option => {
  return request(PlusProductWeb.SendNotifyForHandle, {
    method: METHODS.POST,
    ...option,
  })
}
// 方案产品-查看打包
export const getPackTreeNodeList = async options => {
  return request(PlusProductWeb.GetPackTreeNodeList, {
    method: METHODS.POST,
    ...options,
  })
}
// 方案产品- 分页
export const getAuthProductManagementPage = async options => {
  return request(PlusProductWeb.GetAuthProductManagementPage, {
    method: METHODS.POST,
    ...options,
  })
}
// 标配情况- 分页
export const getAuthGeneralStandardPage = async options => {
  return request(PlusProductWeb.GetAuthGeneralStandardPage, {
    method: METHODS.POST,
    ...options,
  })
}

export const batchUpdateProductLibrary = async data => {
  return request(PlusProductWeb.BatchUpdateProductLibrary, {
    method: METHODS.POST,
    data,
  })
}
export const batchInsertSpuRelation = async data => {
  return request(PlusProductWeb.BatchInsertSpuRelation, {
    method: METHODS.POST,
    data,
  })
}
export const getProdCateTree = async data => {
  return request(PlusProductWeb.GetProdCateTree, {
    method: METHODS.POST,
    data,
  })
}
export const getCategorySpuRelation = async data => {
  return request(PlusProductWeb.GetCategorySpuRelation, {
    method: METHODS.POST,
    data,
  })
}

export const getProductSkuSelectList = async data => {
  return request(PlusProductWeb.GetProductSkuSelectList, {
    method: METHODS.POST,
    data,
  })
}
export const productCombinationDetailSelectList = async data => {
  return request(PlusProductWeb.ProductCombinationDetailSelectList, {
    method: METHODS.POST,
    data,
  })
}
export const productCombinationDetailBatchUpdateDate = async data => {
  return request(PlusProductWeb.ProductCombinationDetailBatchUpdateDate, {
    method: METHODS.POST,
    data,
  })
}
export const productCombinationDetailBatchInsert = async data => {
  return request(PlusProductWeb.ProductCombinationDetailBatchInsert, {
    method: METHODS.POST,
    data,
  })
}
export const productCombinationLog = async data => {
  return request(PlusProductWeb.ProductCombinationLog, {
    method: METHODS.POST,
    data,
  })
}

export const productCombinationEdit = async data => {
  return request(PlusProductWeb.ProductCombinationEdit, {
    method: METHODS.POST,
    data,
  })
}
